import { HOME_CONTENT_WIDGET_ACTION_TYPE } from "./home-content-widget.action";

export const HOME_CONTENT_WIDGET_DOCUMENT_NAME = "homecontentwidget";

export const HOME_CONTENT_WIDGET_CONTEXT = {
	get: HOME_CONTENT_WIDGET_ACTION_TYPE.get,
};
